import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

//Util
import { ICONES_BOTAO } from "../../../utils/icones";
import CardLogAutorizacao from "./card_log_autorizacao";

/*
 * Modal para apresentar os dados do log de autorização
 */
function ModalAutorizacaoLog({
  modalOpen,
  toggleModal,
  titulo,
  autorizacaoLog,
  showFechar = true,
}) {
  return (
    <Modal isOpen={modalOpen} backdrop="static" size="lg">
      <ModalHeader toggle={toggleModal} className="titulo-tela-modal">
        Log
      </ModalHeader>

      <ModalBody>
        {/* <Row className="mb-2">
          <Col>
            <div>
              <Label className="fw-bold me-2">Usuário: </Label>
              {autorizacaoLog.usuario.nome}
            </div>

            <div>
              <Label className="fw-bold me-2">Data: </Label>
              {fn_formatarDataHora(autorizacaoLog.data)}
            </div>
          </Col>
        </Row>

        <Row>
          <Col>{fn_formatarLog(autorizacaoLog.log)}</Col>
        </Row> */}

        <CardLogAutorizacao titulo={titulo} autorizacaoLog={autorizacaoLog} />
      </ModalBody>

      {showFechar && (
        <ModalFooter>
          <Button name="btnFechar" color="secondary" onClick={toggleModal}>
            {ICONES_BOTAO.FECHAR} Fechar
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
}

export default ModalAutorizacaoLog;
